export default __webpack_public_path__ + "static/assets/a9063952002b6bf7c07783960f5cfd64.svg";